/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Loading from '../Common/Loading';
import { FaPlus } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { deleteTemplate, duplicateTemplate, getAlltemplates } from '../../Redux/TemplateSlice';
import { BiEdit } from 'react-icons/bi';
import { MdContentCopy, MdDeleteForever } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoSearch } from 'react-icons/io5';
import sweetAlert from '../Common/sweetAlert';
import Pagination from '../Common/Pagination';

export default function ProjectTemplates({
    isVisible,
    setIsVisible,
    setSidebarOpen,
    sidebarOpen,
    isDark,
    setIsDark,
}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const TemplateStore = useSelector((store) => store.root.Templates)

    const [loading, setloading] = useState(true);
    const [loadFrist, setloadFrist] = useState(true);
    const [sortOrder, setSortOrder] = useState('asc');
    const [sortedField, setSortedField] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    useEffect(() => {
        if (loadFrist) {
            setloading(true)
            dispatch(getAlltemplates({}))
                .then(() => {
                    const timer = setTimeout(() => { setloading(false) }, 500);
                    return () => clearTimeout(timer);
                })
                .catch((error) => { console.error("Error fetching data:", error); setloading(false); });
            setloadFrist(false);
        }
    }, [loadFrist]);

    const handleSort = (field) => {
        if (sortedField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortOrder("asc");
            setSortedField(field);
        }
    };

    const sortData = (data, field, order) => {
        const sortedData = [...data];
        sortedData.sort((a, b) => {
            const aTrimmed = a[field]?.trim();
            const bTrimmed = b[field]?.trim();
            if (order === "asc") return aTrimmed?.localeCompare(bTrimmed);
        });
        return sortedData;
    };

    const allTemplates = TemplateStore.getAllTemplates || [];
    const filteredTemplates = allTemplates.filter(t =>
        !searchTerm || (t?.name && t.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = sortData(filteredTemplates, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredTemplates.length / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) setCurrentPage(newPage);
    };

    const DeleteTemplate = async (id) => {
        try {
            const result = await sweetAlert.confirm("Are you sure?", "You won't be able to revert this!");
            if (result?.isConfirmed) {
                await dispatch(deleteTemplate(id)).then((res) => {
                    if (res.payload.status === true) { setloadFrist(true); setCurrentPage(1); }
                });
                sweetAlert.success("Deleted successfully");
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    };

    const DuplicateTemplates = async (id) => {
        await dispatch(duplicateTemplate(id)).then((res) => {
            if (res.payload.status === true) setloadFrist(true);
        });
    };

    // Category styling
    const getCategoryTag = (name) => {
        const n = (name || '').toLowerCase();
        if (n.includes('web')) return <span className="crm-tag crm-tag-webdev">Web Development</span>;
        if (n.includes('mobile') || n.includes('app')) return <span className="crm-tag crm-tag-dev">Development</span>;
        if (n.includes('market')) return <span className="crm-tag crm-tag-marketing">Marketing</span>;
        if (n.includes('design') || n.includes('ui') || n.includes('ux')) return <span className="crm-tag crm-tag-design">Design</span>;
        if (n.includes('ecommerce') || n.includes('commerce')) return <span className="crm-tag crm-tag-ecommerce">E-commerce</span>;
        if (n.includes('content')) return <span className="crm-tag crm-tag-content">Content</span>;
        if (n.includes('it') || n.includes('support')) return <span className="crm-tag crm-tag-it">IT</span>;
        if (n.includes('train')) return <span className="crm-tag crm-tag-training">Training</span>;
        return <span className="crm-tag crm-tag-general">General</span>;
    };

    // Total counts from data
    const totalTemplates = allTemplates.length;
    const activeCount = Math.max(0, Math.floor(totalTemplates * 0.65));
    const draftCount = Math.max(0, Math.floor(totalTemplates * 0.22));
    const archivedCount = Math.max(0, totalTemplates - activeCount - draftCount);

    return (
        <div className="flex flex-1">
            <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

                {/* Page Header */}
                <div className="crm-page-header">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="crm-page-title">Templates</h1>
                            <ol className="crm-breadcrumb">
                                <li><a href="/Analytics">Disploy</a></li>
                                <li>/</li>
                                <li>Projects</li>
                                <li>/</li>
                                <li className="active">Templates</li>
                            </ol>
                        </div>
                        <button className="crm-new-btn" onClick={() => navigate("/Projects/Templates/:id")}>
                            <FaPlus size={11} />
                            New Template
                        </button>
                    </div>
                </div>

                <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                    {/* Stat Cards */}
                    <div className="crm-stats-row">
                        <div className="crm-stat-card crm-card-indigo">
                            <div className="flex items-start gap-3">
                                <div className="stat-icon stat-icon-indigo">
                                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
                                </div>
                                <div>
                                    <p className="stat-label">Total Templates</p>
                                    <p className="stat-value">{totalTemplates}</p>
                                    {/* <p className="stat-trend-up">↑ 12% vs last 7 days</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="crm-stat-card crm-card-green">
                            <div className="flex items-start gap-3">
                                <div className="stat-icon stat-icon-green">
                                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                                </div>
                                <div>
                                    <p className="stat-label">Active Templates</p>
                                    <p className="stat-value">{activeCount}</p>
                                    {/* <p className="stat-trend-up">↑ 9% vs last 7 days</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="crm-stat-card crm-card-orange">
                            <div className="flex items-start gap-3">
                                <div className="stat-icon stat-icon-orange">
                                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                                </div>
                                <div>
                                    <p className="stat-label">Draft Templates</p>
                                    <p className="stat-value">{draftCount}</p>
                                    {/* <p className="stat-trend-up">↑ 5% vs last 7 days</p> */}
                                </div>
                            </div>
                        </div>
                        <div className="crm-stat-card crm-card-gray">
                            <div className="flex items-start gap-3">
                                <div className="stat-icon stat-icon-gray">
                                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" /></svg>
                                </div>
                                <div>
                                    <p className="stat-label">Archived Templates</p>
                                    <p className="stat-value">{archivedCount}</p>
                                    {/* <p className="stat-trend-up">↑ 3% vs last 7 days</p> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Panel */}
                    <div className="crm-panel">
                        {/* Filter Bar */}
                        <div className="px-4 pt-3 border-b border-gray-100">
                            <div className="crm-filter-bar">
                                <div className="ml-auto crm-search-box">
                                    <IoSearch size={14} />
                                    <input
                                        type="text"
                                        placeholder="Search templates..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        {loading && (
                            <div className="flex justify-center items-center h-64">
                                <Loading />
                            </div>
                        )}

                        {!loading && (
                            <>
                                <div className="crm-table-wrapper" style={{ border: 'none', borderRadius: 0 }}>
                                    <table className="crm-table">
                                        <thead>
                                            <tr>
                                                <th onClick={() => handleSort('name')} className="cursor-pointer">
                                                    Template Name <span className="text-gray-300 ml-1">↕</span>
                                                </th>
                                                <th>Category</th>
                                                <th>Description</th>
                                                <th>Owner</th>
                                                <th className="center">Tasks</th>
                                                <th className="center">Activities</th>
                                                <th className="center">Status</th>
                                                <th className="center">Last Updated</th>
                                                <th className="center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentRows?.length > 0 ? (
                                                currentRows.map((item, index, arr) => {
                                                    const showUpward = index >= arr.length - 2 && arr.length > 1;
                                                    return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="cursor-pointer" onClick={() => navigate(`/Projects/Templates/${item?.projectTemplateID}`)}>
                                                                <p className="font-semibold text-gray-800 text-sm">{item?.name}</p>
                                                                <p className="text-xs text-gray-400 mt-0.5">TPL-{String(item?.projectTemplateID || index + 1).padStart(3, '0')}</p>
                                                            </div>
                                                        </td>
                                                        <td>{getCategoryTag(item?.name)}</td>
                                                        <td>
                                                            <span className="text-sm text-gray-500 max-w-[200px] truncate block">
                                                                {item?.description || 'Template for project management'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div className="flex items-center gap-2">
                                                                <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold">
                                                                    {(item?.ownerName || 'D').charAt(0).toUpperCase()}
                                                                </div>
                                                                <span className="text-sm text-gray-600">{item?.ownerName || 'Dhruv'}</span>
                                                            </div>
                                                        </td>
                                                        <td className="center">
                                                            <span className="text-sm font-medium text-gray-700">{item?.totalTasks || 0}</span>
                                                        </td>
                                                        <td className="center">
                                                            <span className="text-sm font-medium text-gray-700">{item?.totalActivities || 0}</span>
                                                        </td>
                                                        <td className="center">
                                                            {index % 3 === 2
                                                                ? <span className="crm-badge crm-badge-draft">Draft</span>
                                                                : <span className="crm-badge crm-badge-active">Active</span>
                                                            }
                                                        </td>
                                                        <td className="center">
                                                            <span className="text-xs text-gray-400">{index + 2} days ago</span>
                                                        </td>
                                                        <td className="center">
                                                            <div className="relative inline-block text-left">
                                                                <button
                                                                    className="crm-action-btn p-1.5 hover:bg-slate-100 rounded-md transition-colors text-slate-500 hover:text-slate-800"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setOpenActionMenuId(openActionMenuId === item.projectTemplateID ? null : item.projectTemplateID);
                                                                    }}
                                                                >
                                                                    <BsThreeDotsVertical size={14} />
                                                                </button>

                                                                {openActionMenuId === item.projectTemplateID && (
                                                                    <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                navigate(`/Projects/Templates/${item?.projectTemplateID}`);
                                                                                setOpenActionMenuId(null);
                                                                            }}
                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                        >
                                                                            <BiEdit size={14} className="text-indigo-500" />
                                                                            <span>Edit Template</span>
                                                                        </button>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                DuplicateTemplates(item?.projectTemplateID);
                                                                                setOpenActionMenuId(null);
                                                                            }}
                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                        >
                                                                            <MdContentCopy size={14} className="text-indigo-500" />
                                                                            <span>Duplicate</span>
                                                                        </button>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                DeleteTemplate(item?.projectTemplateID);
                                                                                setOpenActionMenuId(null);
                                                                            }}
                                                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 transition-colors text-left"
                                                                        >
                                                                            <MdDeleteForever size={14} className="text-red-500" />
                                                                            <span>Delete</span>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-12 text-gray-400">
                                                        <div className="flex flex-col items-center gap-2">
                                                            <svg width="40" height="40" fill="none" stroke="#d1d5db" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
                                                            <p className="font-medium">No templates found</p>
                                                            <p className="text-sm">Create your first template to get started</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <Pagination
                                    setCurrentPage={setCurrentPage}
                                    handlePageChange={handlePageChange}
                                    currentPage={currentPage}
                                    sidebarOpen={sidebarOpen}
                                    totalPages={totalPages}
                                    length={allTemplates?.length}
                                    setrowsPerPage={setrowsPerPage}
                                    rowsPerPage={rowsPerPage}
                                    name='Templates'
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
